import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import useWindowWidth from '../../hooks/useWindowWidth';
import './Dashboard.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function RevenueVsExpenseChart({ data }) {
    const width = useWindowWidth();
    const isMobile = width < 768;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: isMobile ? 'bottom' : 'top',
                labels: {
                    boxWidth: isMobile ? 12 : 16,
                    padding: isMobile ? 8 : 10,
                    font: { size: isMobile ? 11 : 12 },
                },
            },
            title: {
                display: !isMobile,
                text: 'Evolução de Receitas e Despesas no Período',
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    font: { size: isMobile ? 10 : 12 },
                    maxRotation: isMobile ? 45 : 0,
                },
            },
            y: {
                stacked: true,
                ticks: {
                    font: { size: isMobile ? 10 : 12 },
                    callback: (value) => {
                        if (isMobile) {
                            return value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value;
                        }
                        return new Intl.NumberFormat('pt-BR', {
                            style: 'currency', currency: 'BRL',
                            maximumFractionDigits: 0,
                        }).format(value);
                    },
                },
            },
        },
    };

    const chartData = {
        labels: data?.map(d => new Date(d.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })) || [],
        datasets: [
            {
                label: 'Receitas',
                data: data?.map(d => d.revenue) || [],
                backgroundColor: 'rgba(75, 192, 192, 0.5)',
            },
            {
                label: 'Despesas',
                data: data?.map(d => d.expense) || [],
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
        ],
    };

    if (isMobile) {
        return (
            <div className="dash-chart-section-m">
                <p className="dash-chart-title-m">Receitas vs Despesas no Período</p>
                <div style={{ height: '240px' }}>
                    {data ? <Bar options={options} data={chartData} /> : <p style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Carregando...</p>}
                </div>
            </div>
        );
    }

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body" style={{ height: '400px' }}>
                {data ? <Bar options={options} data={chartData} /> : <p>Carregando dados do gráfico...</p>}
            </div>
        </div>
    );
}

export default RevenueVsExpenseChart;
